import Send from "@mui/icons-material/Send";
import { IconButton, TextField } from "@mui/material";
import { useCallback, useState } from "react";
import { useAccountLimitsContext } from "../../../../../context/account-limit-context";
import { PiiGuidanceNotice } from "../../../../../generic/components/pii-guidance-notice";

import type { Selection } from "../use-co-pilot-types";
import type { FC } from "react";

export const RefineInput: FC<{
  prompt?: string;
  suggestion?: string;
  onRefine: (prompt: string) => void;
  selection?: Selection;
  loading?: boolean;
}> = ({ loading, onRefine }) => {
  const [newPrompt, setNewPrompt] = useState("");
  const { enable_pii_guidance } = useAccountLimitsContext();

  const handleRefine = useCallback(() => {
    onRefine(newPrompt);
    setNewPrompt("");
  }, [newPrompt, onRefine]);

  return (
    <>
      {enable_pii_guidance && <PiiGuidanceNotice analyticsId="co-pilot-refine" />}
      <TextField
        fullWidth
        multiline
        maxRows={3}
        value={newPrompt}
        onChange={(e) => setNewPrompt(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
            handleRefine();
          }
        }}
        label="Ask CoPilot to..."
        disabled={loading}
        slotProps={{
          input: {
            endAdornment: (
              <IconButton
                data-analytics-id="lexical-co-pilot-refine"
                data-testid="refine-button"
                onClick={handleRefine}
                disabled={loading || newPrompt.length === 0}
                color="primary"
                sx={{ mx: -1, px: 1, py: 0 }}
              >
                <Send />
              </IconButton>
            ),
          },
        }}
      />
    </>
  );
};
